export enum SignMode {
  Draw = 'draw',
  Type = 'type',
}

export type SignedType = 'signed' | 'text';